import { Card, CardBody, CardHeader, Heading, Skeleton } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { useGetCompanyCaptableQuery } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard } from '@blockpulse3/ui/commons';

import { ShareholderTable } from '../ShareholderTable';

type Props = unknown;

/**
 * CapTableShareholders.
 *
 * @returns {JSX.Element}
 */
export function CapTableShareholders(): JSX.Element {
  const t = useTranslations();

  const { companyId = '' } = useParams();

  const captableReq = useGetCompanyCaptableQuery({ variables: { companyId } });

  if (captableReq.loading) {
    return (
      <Skeleton>
        <Card h="270px" />
      </Skeleton>
    );
  }

  if (captableReq.error) {
    return <ErrorQueryCard />;
  }

  const capTable = captableReq.data?.company?.capTable;
  const shareholders = capTable?.shareholders || [];

  return (
    <Card>
      <CardHeader>
        <Heading size="md">{t('Shareholder', { nb: shareholders.length })}</Heading>
      </CardHeader>
      <CardBody>
        <ShareholderTable capTable={capTable} />
      </CardBody>
    </Card>
  );
}

export type CapTableShareholdersProps = Props;
